import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=78950fe9&"
import script from "./resizer.vue?vue&type=script&lang=js&"
export * from "./resizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78950fe9')) {
      api.createRecord('78950fe9', component.options)
    } else {
      api.reload('78950fe9', component.options)
    }
    module.hot.accept("./resizer.vue?vue&type=template&id=78950fe9&", function () {
      api.rerender('78950fe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/split/resizer.vue"
export default component.exports